import { render, staticRenderFns } from "./PsGroupsDetailHeader.vue?vue&type=template&id=4601b8b2&scoped=true&"
import script from "./PsGroupsDetailHeader.vue?vue&type=script&lang=js&"
export * from "./PsGroupsDetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./PsGroupsDetailHeader.vue?vue&type=style&index=0&id=4601b8b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4601b8b2",
  null
  
)

export default component.exports